import React, { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { URLS } from "../Url";

const C = { primary:"#5E0E73", dark:"#1A0030", primaryPale:"#F3E5F7", goldLight:"#E8D5A0" };
const EVENT_TYPES = ["Birthday Celebration","Love Proposal","Marriage Proposal","Anniversary","Bride To Be","Groom To Be","Birthday Surprise","Mom To Be","Dad To Be","Farewell Party","Baby Shower","Kitty Party"];

export default function EnquiryForm({ Contact }) {
  const [form,     setForm]     = useState({ name:"", email:"", mobileNumber:"", description:"", eventName:"" });
  const [formStep, setFormStep] = useState(0);

  const handleChange = useCallback(e => setForm(f => ({ ...f, [e.target.name]: e.target.value })), []);

  const handleSubmit = useCallback(e => {
    e.preventDefault();
    axios.post(URLS.AddEnquiry, form).then(r => {
      if (r.status === 200) {
        toast.success(r.data.message);
        setForm({ name:"", email:"", mobileNumber:"", description:"", eventName:"" });
        setFormStep(0);
      }
    }).catch(err => { if (err.response?.status === 400) toast.error(err.response.data.message); });
  }, [form]);

  const contactItems = [
    { icon:"📞", label:"Call Us",    val:"+91 8341428342",                      href:"tel:8341428342" },
    { icon:"💬", label:"WhatsApp",   val:"+91 8341428342",                      href:"https://wa.me/918341428342" },
    { icon:"📧", label:"Email",      val:Contact?.email || "carnivalcastle02@gmail.com", href:`mailto:${Contact?.email}` },
    { icon:"📍", label:"Location",   val:Contact?.address || "Hyderabad, Telangana",     href:null },
  ];

  return (
    <section className="cc-sec cc-sec-beige" id="enquiry">
      <div className="container">
        <div className="text-center rv" style={{ marginBottom:48 }}>
          <span className="cc-tag">✦ Get In Touch ✦</span>
          <h2 className="cc-h">Plan Your <span>Perfect Event</span></h2>
          <p className="cc-sub">Fill in the form and our team will respond within 2 hours with a personalised plan.</p>
        </div>
        <div className="enq-wrap rv" style={{ maxWidth:1060, margin:"0 auto" }}>
          <div className="row g-0">
            {/* Left */}
            <div className="col-lg-4">
              <div className="enq-left h-100">
                <div>
                  <h3 className="pf" style={{ color:"#fff", fontSize:26, fontWeight:700, marginBottom:8 }}>
                    Let's Create <span style={{ color:C.goldLight }}>Magic</span> Together
                  </h3>
                  <p style={{ color:"rgba(255,255,255,.6)", fontSize:13, lineHeight:1.7, marginBottom:32 }}>
                    Share your event details and we'll craft an unforgettable private theatre experience for you.
                  </p>
                  <div style={{ marginBottom:8 }}>
                    <div style={{ fontSize:10, color:"rgba(255,255,255,.4)", letterSpacing:1, textTransform:"uppercase", marginBottom:6 }}>Form Progress</div>
                    <div className="enq-step-bar">
                      {[0,1,2].map(s => <div key={s} className={`enq-step${formStep >= s ? " done" : ""}`} />)}
                    </div>
                    <div style={{ fontSize:11, color:"rgba(255,255,255,.4)", marginTop:6 }}>Step {formStep + 1} of 3</div>
                  </div>
                </div>
                <div>
                  {contactItems.map((it, i) => (
                    <div key={i} className="enq-contact-info">
                      <div className="enq-ci-icon">{it.icon}</div>
                      <div>
                        <div className="enq-ci-label">{it.label}</div>
                        {it.href
                          ? <a href={it.href} style={{ color:"#fff", fontWeight:500, fontSize:13, textDecoration:"none" }}>{it.val}</a>
                          : <span style={{ color:"#fff", fontWeight:500, fontSize:13 }}>{it.val}</span>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Right */}
            <div className="col-lg-8">
              <div className="enq-right">
                <h3 className="pf" style={{ fontSize:22, fontWeight:700, color:C.dark, marginBottom:4 }}>
                  We'd Love To Hear <span style={{ color:C.primary }}>From You!</span>
                </h3>
                <p style={{ color:"#aaa", fontSize:13, marginBottom:28 }}>Your celebration, your way — tell us what you have in mind.</p>
                <form onSubmit={handleSubmit}>
                  {formStep === 0 && (
                    <div>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="enq-label">Your Name</label>
                          <input className="enq-input" name="name" value={form.name} onChange={handleChange} placeholder="e.g. Priya Sharma" required />
                        </div>
                        <div className="col-md-6">
                          <label className="enq-label">Phone Number</label>
                          <input className="enq-input" name="mobileNumber" value={form.mobileNumber} onChange={handleChange} placeholder="+91 00000 00000" required />
                        </div>
                        <div className="col-12">
                          <label className="enq-label">Email Address</label>
                          <input className="enq-input" name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@email.com" required />
                        </div>
                      </div>
                      <button type="button" className="cc-btn" style={{ width:"100%", marginTop:24, padding:"14px" }}
                        onClick={() => { if (form.name && form.mobileNumber && form.email) setFormStep(1); else toast.warn("Please fill all fields."); }}>
                        Next: Choose Occasion →
                      </button>
                    </div>
                  )}
                  {formStep === 1 && (
                    <div>
                      <label className="enq-label" style={{ marginBottom:12 }}>Select Your Occasion</label>
                      <div className="enq-occasion-grid">
                        {EVENT_TYPES.map((ev, i) => (
                          <div key={i} className={`enq-occ-chip${form.eventName === ev ? " sel" : ""}`}
                            onClick={() => setForm(f => ({ ...f, eventName:ev }))}>{ev}</div>
                        ))}
                      </div>
                      <div style={{ display:"flex", gap:10, marginTop:8 }}>
                        <button type="button" className="cc-btn-outline" style={{ flex:1, padding:"13px" }} onClick={() => setFormStep(0)}>← Back</button>
                        <button type="button" className="cc-btn" style={{ flex:2, padding:"13px" }}
                          onClick={() => { if (form.eventName) setFormStep(2); else toast.warn("Please select an occasion."); }}>
                          Next: Your Message →
                        </button>
                      </div>
                    </div>
                  )}
                  {formStep === 2 && (
                    <div>
                      <div className="enq-field">
                        <label className="enq-label">Tell Us About Your Event</label>
                        <textarea className="enq-input" name="description" value={form.description} onChange={handleChange} rows={5}
                          placeholder={`Tell us about your ${form.eventName || "event"} — number of guests, preferred date, any special requests…`} />
                      </div>
                      <div style={{ background:C.primaryPale, borderRadius:14, padding:"14px 18px", marginBottom:20, border:"1px solid rgba(94,14,115,.1)" }}>
                        <div style={{ fontSize:11, fontWeight:700, color:C.primary, textTransform:"uppercase", letterSpacing:1, marginBottom:8 }}>Summary</div>
                        <div style={{ fontSize:13, color:C.dark }}>
                          <span style={{ fontWeight:600 }}>{form.name}</span> · {form.mobileNumber} · {form.email}<br />
                          <span style={{ color:C.primary, fontWeight:600 }}>🎉 {form.eventName}</span>
                        </div>
                      </div>
                      <div style={{ display:"flex", gap:10 }}>
                        <button type="button" className="cc-btn-outline" style={{ flex:1, padding:"13px" }} onClick={() => setFormStep(1)}>← Back</button>
                        <button type="submit" className="cc-btn" style={{ flex:2, padding:"13px", fontSize:15 }}>✨ Send My Request</button>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}